import { LmsProfileTypes } from 'enum/lms-profile-types.enum'
import { AllCompany } from 'components/configuration/components/lms-profiles/typesProfiles'
import { Participants, Segments } from './components'

interface ProfileTypesProps {
  value?: LmsProfileTypes | null
}

const components = {
  [LmsProfileTypes.allUsers]: <AllCompany />,
  [LmsProfileTypes.participants]: <Participants />,
  [LmsProfileTypes.segments]: <Segments />,
}

export const ProfileTypes = ({ value }: ProfileTypesProps) => {
  const Component = value && components[value]
  return <div>{Component}</div>
}
